import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import FormInputText from '../../common/Forms/FormTextField';
import InputDropdown from '../../common/Forms/InputDropdown';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import {
  EPISODE_PROFA2_URL,
  EPISODE_PROFA_URL,
  formDateFormat,
  PROFA1_REFERRAL_UPDATE_DATA,
  yesNoDropdown,
} from '../../../constants';
import {
  getProfA1Form,
  setParticipantName,
  setPermanentAddress,
  setPermanentCity,
  setPermanentZipCode,
  setSecondaryScore,
  setCDCNumber,
  setDOB,
  setCountyofLastLegalResidence,
  setParoleRegion,
  setSat,
  setSatShortName,
  setCsarScore,
  setAsiScore,
  setTelephoneNumber,
  setMaritalStatusId,
  setEthnicGroupId,
  setPrimaryLanguage,
  setHighestEducationId,
  setUsualOccupation,
  setYears,
  setNumberofChildren,
  setAges,
  setIsCSBOrCPSInvolved,
  setChildrenLiveWith,
  setEmergencyContact1Name,
  setEmergencyContact1Address,
  setEmergencyContact1City,
  setEmergencyContact1Phone,
  setEmergencyContact1Relationship,
  setEmergencyContact2Name,
  setEmergencyContact2Address,
  setEmergencyContact2City,
  setEmergencyContact2Phone,
  setEmergencyContact2Relationship,
  setClassifiedCCCMS,
  setClassifiedCCCMSYear,
  setClassifiedCCCMSClearedYear,
  setMedComments,
  setMedicineName2,
  setMedicineName1,
  setMedicineName3,
  setMedicineCondition1,
  setMedicineCondition2,
  setMedicineCondition3,
  setVeteran,
  setADA,
  setIsProfA1DataLoaded,
} from '../../../redux/episode/profA1Tab/profA1FormSlice';
import FormInputMultiCheckbox from '../../common/Forms/FormCheckbox';
import { setStopApi } from '../../../services/StopApi/StopApi';
import FormSuccess from '../../common/Forms/FormSuccess';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import CancelPopUp from '../../common/CancelPopUp/CancelPopUp';
import { setRefreshEpisodeParticipant } from '../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import { getSaveCancel } from '../../common/commonUtils/commonUtils';
import ProfA1PdfForm from './ProfA1PdfForm';
import { InputFeildGrid } from './ProfA1PdfFormStyled';
import { getProfA2Form } from '../../../redux/episode/profA2Tab/profA2FormSlice';
import { PrintViewGrid } from './ProfA1PdfFormCommonUtils';

const ProfA1 = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [formLoading, setFormLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [openProfileA1PDF, setOpenProfileA1PDF] = useState(false);
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );
  const profA1Form = useSelector((state) => state?.profA1Form);
  const profA1Info = useSelector((state) => state?.profA1ReferenceData);

  const { numberofChildren } = profA1Form || {};

  const defaultValue = {
    participantName: profA1Form?.participant?.participantName,
    CDCNumber: profA1Form?.CDCNumber,
    DOB: moment(profA1Form?.participant?.DOB).format(formDateFormat),
    countyofLastLegalResidence: profA1Form?.countyofLastLegalResidence?.value,
    paroleRegion: profA1Form?.paroleRegion?.value,
    SAT: profA1Form?.SAT?.id,
    OSAPParoleAgent: profA1Form?.OSAPParoleAgent?.organization?.value,
    CSRAScore: profA1Form?.CSRAScore,
    ASIScore: profA1Form?.ASIScore,
    secondaryScore: profA1Form?.secondaryScore,
    permanentAddress: profA1Form?.permanentAddress,
    permanentCity: profA1Form?.permanentCity,
    permanentZipCode: profA1Form?.permanentZipCode,
    permanentTelephone: profA1Form?.permanentTelephone,
    maritalStatusId: profA1Form?.maritalStatusId
      ? profA1Form?.maritalStatusId
      : '',
    primaryLanguage: profA1Form?.primaryLanguage
      ? profA1Form?.primaryLanguage
      : '',
    highestEducationId: profA1Form?.highestEducationId
      ? profA1Form?.highestEducationId
      : '',
    usualOccupation: profA1Form?.usualOccupation,
    veteran: profA1Form?.veteran,
    ADA: profA1Form?.ADA,
    years: profA1Form?.years,
    numberofChildren: profA1Form?.numberofChildren,
    Ages: profA1Form?.Ages,
    childrenLiveWith: profA1Form?.childrenLiveWith,
    isCSBOrCPSInvolved:
      profA1Form?.isCSBOrCPSInvolved === null
        ? ''
        : profA1Form?.isCSBOrCPSInvolved,
    emergencyContact1Name: profA1Form?.emergencyContact1Name,
    emergencyContact1Address: profA1Form?.emergencyContact1Address,
    emergencyContact1City: profA1Form?.emergencyContact1City,
    emergencyContact1Phone: profA1Form?.emergencyContact1Phone,
    emergencyContact1Relationship: profA1Form?.emergencyContact1Relationship,
    emergencyContact2Name: profA1Form?.emergencyContact2Name,
    emergencyContact2Address: profA1Form?.emergencyContact2Address,
    emergencyContact2City: profA1Form?.emergencyContact2City,
    emergencyContact2Phone: profA1Form?.emergencyContact2Phone,
    emergencyContact2Relationship: profA1Form?.emergencyContact2Relationship,
    classifiedCCCMS:
      profA1Form?.classifiedCCCMS === null ? '' : profA1Form?.classifiedCCCMS,
    classifiedCCCMSYear: profA1Form?.classifiedCCCMSYear,
    classifiedCCCMSClearedYear: profA1Form?.classifiedCCCMSClearedYear,
    medComments: profA1Form?.medComments,
    medicineName1: profA1Form?.medicineName1,
    medicineName2: profA1Form?.medicineName2,
    medicineName3: profA1Form?.medicineName3,
    medicineCondition1: profA1Form?.medicineCondition1,
    medicineCondition2: profA1Form?.medicineCondition2,
    medicineCondition3: profA1Form?.medicineCondition3,
    ethnicGroupId: profA1Form?.participant?.ethnicGroupId
      ? profA1Form?.participant?.ethnicGroupId
      : '',
  };
  const useFunction = useForm({ defaultValues: defaultValue });
  const { handleSubmit, reset, control, setValue, watch, register } =
    useFunction;

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.participantName,
    defaultValue.CDCNumber,
    defaultValue.DOB,
    defaultValue.countyofLastLegalResidence,
    defaultValue.paroleRegion,
    defaultValue.SAT,
    defaultValue.OSAPParoleAgent,
    defaultValue.CSRAScore,
    defaultValue.ASIScore,
    defaultValue.secondaryScore,
    defaultValue.permanentAddress,
    defaultValue.permanentCity,
    defaultValue.permanentZipCode,
    defaultValue.permanentTelephone,
    defaultValue.maritalStatusId,
    defaultValue.ethnicGroupId,
    defaultValue.primaryLanguage,
    defaultValue.highestEducationId,
    defaultValue.usualOccupation,
    defaultValue.years,
    defaultValue.numberofChildren,
    defaultValue.Ages,
    defaultValue.isCSBOrCPSInvolved,
    defaultValue.childrenLiveWith,
    defaultValue.emergencyContact1Name,
    defaultValue.emergencyContact1Address,
    defaultValue.emergencyContact1City,
    defaultValue.emergencyContact1Phone,
    defaultValue.emergencyContact1Relationship,
    defaultValue.ADA,
    defaultValue.veteran,
    defaultValue.emergencyContact2Name,
    defaultValue.emergencyContact2Address,
    defaultValue.emergencyContact2City,
    defaultValue.emergencyContact2Phone,
    defaultValue.emergencyContact2Relationship,
    defaultValue.classifiedCCCMS,
    defaultValue.classifiedCCCMSYear,
    defaultValue.classifiedCCCMSClearedYear,
    defaultValue.medComments,
    defaultValue.medicineName1,
    defaultValue.medicineName2,
    defaultValue.medicineName3,
    defaultValue.medicineCondition1,
    defaultValue.medicineCondition2,
    defaultValue.medicineCondition3,
  ]);

  const onSubmit = () => {
    const url = PROFA1_REFERRAL_UPDATE_DATA;
    const payload = {
      episodeID: episodeId,
      CSRAScore: profA1Form?.CSRAScore,
      ASIScore: profA1Form?.ASIScore,
      secondaryScore: profA1Form?.secondaryScore,
      permanentAddress: profA1Form?.permanentAddress,
      permanentCity: profA1Form?.permanentCity,
      permanentZipCode: profA1Form?.permanentZipCode,
      permanentTelephone: profA1Form?.permanentTelephone,
      veteran: profA1Form?.veteran,
      ADA: profA1Form?.ADA,
      usualOccupation: profA1Form?.usualOccupation,
      years: profA1Form?.years,
      numberofChildren: numberofChildren || null,
      Ages: profA1Form?.Ages,
      isCSBOrCPSInvolved:
        profA1Form?.isCSBOrCPSInvolved === ''
          ? null
          : profA1Form?.isCSBOrCPSInvolved,
      childrenLiveWith: profA1Form?.childrenLiveWith,
      emergencyContact1Name: profA1Form?.emergencyContact1Name,
      emergencyContact1Address: profA1Form?.emergencyContact1Address,
      emergencyContact1City: profA1Form?.emergencyContact1City,
      emergencyContact1Phone: profA1Form?.emergencyContact1Phone,
      emergencyContact1Relationship: profA1Form?.emergencyContact1Relationship,
      emergencyContact2Name: profA1Form?.emergencyContact2Name,
      emergencyContact2Address: profA1Form?.emergencyContact2Address,
      emergencyContact2City: profA1Form?.emergencyContact2City,
      emergencyContact2Phone: profA1Form?.emergencyContact2Phone,
      emergencyContact2Relationship: profA1Form?.emergencyContact2Relationship,
      everDiagnosedwithMentalHealthIssue:
        profA1Form?.everDiagnosedwithMentalHealthIssue,
      historyofSuicideAttemptsPsychIssuesReportedbyPart:
        profA1Form?.historyofSuicideAttemptsPsychIssuesReportedbyPart,
      classifiedCCCMS:
        profA1Form?.classifiedCCCMS === '' ? null : profA1Form?.classifiedCCCMS,
      classifiedCCCMSYear: profA1Form?.classifiedCCCMSYear,
      classifiedCCCMSClearedYear: profA1Form?.classifiedCCCMSClearedYear,
      medComments: profA1Form?.medComments,
      medicineName1: profA1Form?.medicineName1,
      medicineCondition1: profA1Form?.medicineCondition1,
      medicineName2: profA1Form?.medicineName2,
      medicineCondition2: profA1Form?.medicineCondition2,
      medicineName3: profA1Form?.medicineName3,
      medicineCondition3: profA1Form?.medicineCondition3,
      primaryLanguage: profA1Form?.primaryLanguage
        ? profA1Form?.primaryLanguage
        : null,
      maritalStatus: profA1Form?.maritalStatusId
        ? profA1Form?.maritalStatusId
        : null,
      empStatus: profA1Form?.empStatus,
      highestEducation: profA1Form?.highestEducationId
        ? profA1Form?.highestEducationId
        : null,
      EthnicGroup: profA1Form?.participant?.ethnicGroupId
        ? profA1Form?.participant?.ethnicGroupId
        : null,
    };
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        setFormSuccess(true);
        dispatch(setRefreshEpisodeParticipant(true));
        setTimeout(() => {
          dispatch(setRefreshEpisodeParticipant(false));
        }, 1000);
      }
    }).catch((e) => alert(e));
  };

  const fetchData = async () => {
    let commonParams = `${EPISODE_PROFA_URL}/${episodeId}/ProfA1`;
    let profA2TabUrl = `${EPISODE_PROFA2_URL}/${episodeId}/ProfA2`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    //if (profA1Form?.isProfA1DataLoaded === false) {
      dispatch(getProfA1Form({ commonParams, authorization }));
      dispatch(getProfA2Form({ profA2TabUrl, authorization }));
      setTimeout(() => {
        dispatch(setIsProfA1DataLoaded(true));
      }, 1000);
    //}
    setTimeout(() => {
      setFormLoading(false);
    }, 500);
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  const handleOpenA1Pdf = () => {
    onSubmit();
    setOpenProfileA1PDF(true);
  };

  if (formLoading) {
    return <ProgressBar />;
  }
  return (
    <>
      <PrintViewGrid handleOpenPdf={handleOpenA1Pdf} />
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <InputFeildGrid item xs={12} sm={3}>
          <FormInputText
            name="participantName"
            control={control}
            type="text"
            label="Participant Name (Last, First)"
            disabled={true}
            register={register('participantName', {
              onBlur: (e) => dispatch(setParticipantName(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="CDCNumber"
            control={control}
            type="text"
            label="CDC Number"
            disabled={true}
            register={register('CDCNumber', {
              onBlur: (e) => dispatch(setCDCNumber(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="DOB"
            control={control}
            type="date"
            label="DOB"
            disabled={true}
            shrink={true}
            register={register('DOB', {
              onBlur: (e) => dispatch(setDOB(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="countyofLastLegalResidence"
            control={control}
            type="text"
            label="County Of Last Legal Residency(CLLR)"
            disabled={true}
            register={register('countyofLastLegalResidence', {
              onBlur: (e) =>
                dispatch(setCountyofLastLegalResidence(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="paroleRegion"
            control={control}
            type="text"
            label="Parole Region"
            disabled={true}
            register={register('paroleRegion', {
              onBlur: (e) => dispatch(setParoleRegion(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="SAT"
            control={control}
            type="text"
            label="SAT ID"
            disabled={true}
            register={register('SAT', {
              onBlur: (e) => dispatch(setSat(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="OSAPParoleAgent"
            control={control}
            type="text"
            label="SAT Short Name"
            disabled={true}
            // register={register('satShortName', {
            //   onBlur: (e) => dispatch(setSatShortName(e.target.value)),
            // })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="CSRAScore"
            control={control}
            type="text"
            label="CSRA Score"
            register={register('CSRAScore', {
              onBlur: (e) => dispatch(setCsarScore(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="ASIScore"
            control={control}
            type="text"
            label="ASI Score"
            register={register('ASIScore', {
              onBlur: (e) => dispatch(setAsiScore(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="secondaryScore"
            control={control}
            type="text"
            label="Secondary Score"
            register={register('secondaryScore', {
              onBlur: (e) => dispatch(setSecondaryScore(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </InputFeildGrid>
        <InputFeildGrid item xs={12} sm={3}>
          <FormInputText
            name="permanentAddress"
            control={control}
            type="text"
            label="Permanent Address (Number and Street)"
            register={register('permanentAddress', {
              onBlur: (e) => dispatch(setPermanentAddress(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="permanentCity"
            control={control}
            type="text"
            label="City"
            register={register('permanentCity', {
              onBlur: (e) => dispatch(setPermanentCity(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="permanentZipCode"
            control={control}
            type="text"
            label="Zip Code"
            register={register('permanentZipCode', {
              onBlur: (e) => dispatch(setPermanentZipCode(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="permanentTelephone"
            control={control}
            type="text"
            label="Telephone Number (With Area Code)"
            register={register('permanentTelephone', {
              onBlur: (e) => dispatch(setTelephoneNumber(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="maritalStatusId"
            control={control}
            label="Marital Status"
            options={profA1Info?.maritalStatuses}
            defaultId={defaultValue?.maritalStatusId}
            register={register('maritalStatusId', {
              onBlur: (e) => dispatch(setMaritalStatusId(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="ethnicGroupId"
            control={control}
            label="Ethnic Group"
            options={profA1Info?.ethnicityOrRaces}
            defaultId={defaultValue?.ethnicGroupId}
            register={register('ethnicGroupId', {
              onBlur: (e) => dispatch(setEthnicGroupId(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="primaryLanguage"
            control={control}
            label="Primary Language"
            options={profA1Info?.languages}
            defaultId={defaultValue?.primaryLanguage}
            register={register('primaryLanguage', {
              onBlur: (e) => dispatch(setPrimaryLanguage(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="highestEducationId"
            control={control}
            label="Highest Education"
            options={profA1Info?.educationQualifications}
            defaultId={defaultValue?.highestEducationId}
            register={register('highestEducationId', {
              onBlur: (e) => dispatch(setHighestEducationId(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <Box>
            <FormInputText
              name="usualOccupation"
              control={control}
              type="text"
              label="Usual Occupation"
              register={register('usualOccupation', {
                onBlur: (e) => dispatch(setUsualOccupation(e.target.value)),
              })}
              // error={!!errors.participantName}
              // helperText={errors?.eprd?.message}
            />
            <FormInputText
              name="years"
              control={control}
              type="text"
              label="Years"
              register={register('years', {
                onBlur: (e) => dispatch(setYears(e.target.value)),
              })}
              // error={!!errors.participantName}
              // helperText={errors?.eprd?.message}
            />
          </Box>
        </InputFeildGrid>
        <InputFeildGrid item xs={12} sm={3}>
          <FormInputText
            name="numberofChildren"
            control={control}
            type="text"
            label="Number Of Children"
            register={register('numberofChildren', {
              onBlur: (e) => dispatch(setNumberofChildren(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="Ages"
            control={control}
            type="text"
            label="Ages (Seperate Using Commas)"
            register={register('Ages', {
              onBlur: (e) => dispatch(setAges(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="isCSBOrCPSInvolved"
            control={control}
            label="Is CSB/CPS Involved?"
            options={yesNoDropdown}
            defaultId={defaultValue?.isCSBOrCPSInvolved}
            register={register('isCSBOrCPSInvolved', {
              onBlur: (e) => dispatch(setIsCSBOrCPSInvolved(e.target.value)),
            })}
            //isTrue={true}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="childrenLiveWith"
            control={control}
            type="text"
            label="Children Live With?"
            register={register('childrenLiveWith', {
              onBlur: (e) => dispatch(setChildrenLiveWith(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact1Name"
            control={control}
            type="text"
            id="emergencyContactOne"
            label="Emergency Contact 1 (Last, First)"
            register={register('emergencyContact1Name', {
              onBlur: (e) =>
                dispatch(setEmergencyContact1Name(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact1Address"
            control={control}
            type="text"
            id="addressOne"
            label="Address (Number, street, Zip)"
            register={register('emergencyContact1Address', {
              onBlur: (e) =>
                dispatch(setEmergencyContact1Address(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact1City"
            control={control}
            type="text"
            id="cityOne"
            label="City"
            register={register('emergencyContact1City', {
              onBlur: (e) =>
                dispatch(setEmergencyContact1City(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact1Phone"
            control={control}
            type="text"
            //id='telephoneNumberOne'
            label="Telephone Number"
            register={register('emergencyContact1Phone', {
              onBlur: (e) =>
                dispatch(setEmergencyContact1Phone(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact1Relationship"
            control={control}
            type="text"
            id="releationShipOne"
            label="ReletationShip"
            register={register('emergencyContact1Relationship', {
              onBlur: (e) =>
                dispatch(setEmergencyContact1Relationship(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <Grid container>
            <FormInputMultiCheckbox
              control={control}
              name="ADA"
              label="ADA"
              checked={defaultValue.ADA}
              register={register('ADA', {
                onBlur: (e) => dispatch(setADA(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="veteran"
              label="Veteran"
              checked={defaultValue.veteran}
              register={register('veteran', {
                onBlur: (e) => dispatch(setVeteran(e.target.value)),
              })}
            />
          </Grid>
        </InputFeildGrid>
        <InputFeildGrid item xs={12} sm={3}>
          <FormInputText
            name="emergencyContact2Name"
            control={control}
            type="text"
            id="emergencyContactTwo"
            label="Emergency Contact 2 (Last, First)"
            register={register('emergencyContact2Name', {
              onBlur: (e) =>
                dispatch(setEmergencyContact2Name(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact2Address"
            control={control}
            type="text"
            id="addressTwo"
            label="Address (Number, street, Zip)"
            register={register('emergencyContact2Address', {
              onBlur: (e) =>
                dispatch(setEmergencyContact2Address(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact2City"
            control={control}
            type="text"
            id="cityTwo"
            label="City"
            register={register('emergencyContact2City', {
              onBlur: (e) =>
                dispatch(setEmergencyContact2City(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact2Phone"
            control={control}
            type="text"
            id="emergencyContact2Phone"
            label="Telephone Number"
            register={register('emergencyContact2Phone', {
              onBlur: (e) =>
                dispatch(setEmergencyContact2Phone(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="emergencyContact2Relationship"
            control={control}
            type="text"
            id="releationShipOne"
            label="ReletationShip"
            register={register('emergencyContact2Relationship', {
              onBlur: (e) =>
                dispatch(setEmergencyContact2Relationship(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <InputDropdown
            name="classifiedCCCMS"
            control={control}
            label="Classified CCCMS"
            options={yesNoDropdown}
            defaultId={defaultValue?.classifiedCCCMS}
            register={register('classifiedCCCMS', {
              onBlur: (e) => dispatch(setClassifiedCCCMS(e.target.value)),
            })}
          />
          <FormInputText
            name="classifiedCCCMSYear"
            control={control}
            label="if Yes, Year?"
            register={register('classifiedCCCMSYear', {
              onBlur: (e) => dispatch(setClassifiedCCCMSYear(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="classifiedCCCMSClearedYear"
            control={control}
            label="if Cleared, Year?"
            register={register('classifiedCCCMSClearedYear', {
              onBlur: (e) =>
                dispatch(setClassifiedCCCMSClearedYear(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="medComments"
            control={control}
            type="text"
            label="Med Comments"
            multiline={true}
            rows={3}
            register={register('medComments', {
              onBlur: (e) => dispatch(setMedComments(e.target.value)),
            })}
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </InputFeildGrid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography style={{ color: '#b9b2b2' }}>
            Medication(s) Reported By Participant:
          </Typography>
          <FormInputText
            name="medicineName1"
            control={control}
            type="text"
            register={register('medicineName1', {
              onBlur: (e) => dispatch(setMedicineName1(e.target.value)),
            })}
            //label='Medication(s) Reported By Participant'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="medicineName2"
            control={control}
            type="text"
            register={register('medicineName2', {
              onBlur: (e) => dispatch(setMedicineName2(e.target.value)),
            })}
            //label='Medication(s) Reported By Participant'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="medicineName3"
            control={control}
            type="text"
            register={register('medicineName3', {
              onBlur: (e) => dispatch(setMedicineName3(e.target.value)),
            })}
            //label='Medication(s) Reported By Participant'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography style={{ color: '#b9b2b2' }}>
            Reported condition(s) For Which Medication Was Prescribed:
          </Typography>
          <FormInputText
            name="medicineCondition1"
            control={control}
            type="text"
            register={register('medicineCondition1', {
              onBlur: (e) => dispatch(setMedicineCondition1(e.target.value)),
            })}
            //defaultValue={item.reports}
            //label='Reported condition(s) For Which Medication Was Prescribed'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="medicineCondition2"
            control={control}
            type="text"
            register={register('medicineCondition2', {
              onBlur: (e) => dispatch(setMedicineCondition2(e.target.value)),
            })}
            //defaultValue={item.reports}
            //label='Reported condition(s) For Which Medication Was Prescribed'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
          <FormInputText
            name="medicineCondition3"
            control={control}
            type="text"
            register={register('medicineCondition3', {
              onBlur: (e) => dispatch(setMedicineCondition3(e.target.value)),
            })}
            //defaultValue={item.reports}
            //label='Reported condition(s) For Which Medication Was Prescribed'
            // error={!!errors.participantName}
            // helperText={errors?.eprd?.message}
          />
        </Grid>
      </Grid>
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      <FormSuccess formSuccess={formSuccess} setFormSuccess={setFormSuccess} />
      <CancelPopUp cancelPopUp={cancelPopUp} setCancelPopUp={setCancelPopUp} />
      <ProfA1PdfForm open={openProfileA1PDF} setOpen={setOpenProfileA1PDF} />
    </>
  );
};

export default ProfA1;
